export default "__VITE_ASSET__893af057__"